/**
 * Which backend this admin is pointed at, for the environment badge in the
 * top bar ("so nobody edits prod by accident").
 *
 * Order matters and fails safe:
 *  1. A local Supabase URL is always LOCAL.
 *  2. The production project ref is always PRODUCTION, whatever VITE_APP_ENV says.
 *  3. Otherwise VITE_APP_ENV (dev / staging / prod).
 *  4. An unknown remote project is shown like production.
 */
export type AdminEnv = "LOCAL" | "DEV" | "STAGING" | "PRODUCTION" | "UNKNOWN";

const PROD_PROJECT_REF = "cofvuhglpglkceqymhnt";

export const detectAdminEnv = (
  supabaseUrl: string | undefined = import.meta.env.VITE_SUPABASE_URL,
  appEnv: string | undefined = import.meta.env.VITE_APP_ENV
): AdminEnv => {
  const url = (supabaseUrl || "").toLowerCase();
  if (/^https?:\/\/(localhost|127\.0\.0\.1|\[::1\]|0\.0\.0\.0)(:|\/|$)/.test(url)) return "LOCAL";
  if (url.includes(PROD_PROJECT_REF)) return "PRODUCTION";
  switch ((appEnv || "").toLowerCase()) {
    case "local":
      return "LOCAL";
    case "dev":
    case "development":
      return "DEV";
    case "staging":
      return "STAGING";
    case "prod":
    case "production":
      return "PRODUCTION";
    default:
      return "UNKNOWN";
  }
};

export const ADMIN_ENV: AdminEnv = detectAdminEnv();

export const envBadgeLabel = (env: AdminEnv): string =>
  env === "UNKNOWN" ? "UNKNOWN ENV" : env;
